import React from "react";
import { Spinner } from "../features/auth/components/Shared/Icons";

interface LoadingButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading: boolean;
}

export const LoadingButton: React.FC<LoadingButtonProps> = ({
  isLoading,
  disabled,
  onClick,
  children,
  className = "",
  ...props
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (isLoading) {
      e.preventDefault();
      return;
    }
    if (onClick) onClick(e);
  };

  return (
    <button
      onClick={handleClick}
      disabled={isLoading || disabled}
      className={`flex items-center justify-center gap-2 ${className}`}
      {...props}
    >
      {isLoading && <Spinner />}
      {children}
    </button>
  );
};
